const getInitialValues = (products) => {
  return {
    products: products.reduce((memo, item) => {
      return {
        ...memo,
        [item.id]: {
          quantity: 0,
        },
      };
    }, {}),
  };
};

export default getInitialValues;
